import 'semantic-ui-css/components/dropdown';

const addAttributesNumber = function addAttributesNumber($segment, number) {
  const $attributesContainer = $segment.find('#variantAttributesContainer')

  const currentIndex = parseInt($attributesContainer.attr('data-count'), 10);
  $segment.find('#variantAttributesContainer').attr('data-count', currentIndex + number);
};

const controlAttributesList = function controlAttributesList($segment) {
  $segment.find('#variantAttributesContainer .attribute').each((index, element) => {
    const value = $(element).attr('data-id');
    $segment.find('#umanit_product_variant_attribute_choice').dropdown('set selected', value);
  });
};

const modifyAttributesListOnSelectorElementDelete = function modifyAttributesListOnSelectorElementDelete($segment, removedValue) {
  $segment.find(`#variantAttributesContainer .attributes-group[data-attribute-code="${removedValue}"]`).parent().remove();
};

const modifySelectorOnAttributesListElementDelete = function modifySelectorOnAttributesListElementDelete($segment) {
  $segment.find('.attributes-group button[data-attribute="delete"]').off('click').on('click', (event) => {
    const attributeId = $(event.currentTarget).parents('.attributes-group').attr('data-attribute-code');

    $segment.find('div#variantAttributeChoice > .ui.dropdown.search').dropdown('remove selected', attributeId);
    modifyAttributesListOnSelectorElementDelete($segment, attributeId);
  });
};

const modifyAttributeFormElements = function modifyAttributeFormElements($response) {
  $response.find('input,select,textarea').each((index, element) => {
    if ($(element).attr('data-name') != null) {
      $(element).attr('name', $(element).attr('data-name'));
    }
  });

  return $response;
};

const isInTheAttributesContainer = function isInTheAttributesContainer($segment, attributeId) {
  let result = false;
  $segment.find('#variantAttributesContainer .attribute').each((index, element) => {
    const dataId = $(element).attr('data-id');
    if (dataId === attributeId) {
      result = true;
    }
  });

  return result;
};

const copyValueToAllLanguages = function copyValueToAllLanguages($segment) {
  $segment.find('#variantAttributesContainer').on('click', '.attribute [data-attribute="copy"]', (event) => {
    event.preventDefault();

    const $attributesContainer = $segment.find('#variantAttributesContainer');
    const $masterAttribute = $(event.currentTarget).closest('.attribute');
    const attributeID = $masterAttribute.attr('data-id');
    const $attributeCollection = $attributesContainer.find(`[data-id="${attributeID}"]`);

    const $masterAttributeInputs = $masterAttribute.find('input:visible, select, textarea');

    $attributeCollection.each((index, attr) => {
      const $inputs = $(attr).find('input:visible, select, textarea');

      $inputs.each((i, input) => {
        if (input.getAttribute('type') === 'checkbox') {
          input.checked = $masterAttributeInputs[i].checked;
        } else {
          input.value = $masterAttributeInputs[i].value;
        }
      });
    });
  });
};

const setAttributeChoiceListener = function setAttributeChoiceListener($segment) {
  controlAttributesList($segment);

  $segment.find('button').on('click', (event) => {
    event.preventDefault();

    const $attributeChoiceSelect = $segment.find('select');
    let queryData = '';
    const $newAttributes = $attributeChoiceSelect.val();

    if ($newAttributes != null) {
      $attributeChoiceSelect.val().forEach((item) => {
        if (!isInTheAttributesContainer($segment, item)) {
          queryData += `${$attributeChoiceSelect.prop('name')}=${item}&`;
        }
      });
    }

    const $attributesContainer = $segment.find('#variantAttributesContainer')

    queryData += `count=${$attributesContainer.attr('data-count')}`;
    queryData += `&formId=${$attributesContainer.attr('data-form-id')}`;
    queryData += `&formName=${$attributesContainer.attr('data-form-name')}`;

    $('form').addClass('loading');

    $.ajax({
      type: 'GET',
      url: $(event.currentTarget).parent().attr('data-action'),
      data: queryData,
      dataType: 'html',
      error() {
        $('form').removeClass('loading');
      },
      success(response) {
        const attributeFormElements = modifyAttributeFormElements($(response));

        attributeFormElements.each((index, element) => {
          const localeCode = $(element).find('input[type="hidden"]').last().val();
          $segment.find(`#variantAttributesContainer > div`).append(element);
        });

        $segment.find('#umanit_product_variant_attribute_choice').val('');

        addAttributesNumber($segment, $.grep(attributeFormElements, a => $(a).hasClass('attribute')).length);
        modifySelectorOnAttributesListElementDelete($segment);

        $('form').removeClass('loading');
      },
    });
  });
};

$.fn.extend({
  productVariantAttributes() {
    const root = this;

    $('[data-id="variantAttributesSegment"]').each(function () {
      const $segment = $(this);

      setAttributeChoiceListener($segment);

      const $select = $segment.find('#umanit_product_variant_attribute_choice');

      $select.dropdown({
        onRemove(removedValue) {
          modifyAttributesListOnSelectorElementDelete($segment, removedValue);
        },
        forceSelection: false,
      });

      modifySelectorOnAttributesListElementDelete($segment);
      copyValueToAllLanguages($segment);
    })
  },
});

$(document).ready(() => {
  $('div#variantAttributeChoice > .ui.dropdown.search').productVariantAttributes();
});
